module.exports = __webpack_public_path__ + "img/_3.42eb1e40.png";